// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Caml_int32 from "@rescript/std/lib/es6/caml_int32.js";
import * as Js_promise from "@rescript/std/lib/es6/js_promise.js";
import Classnames from "classnames";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import Player from "@vimeo/player";
import * as JsxRuntime from "react/jsx-runtime";
import * as Hooks$PrezzeeRibbon from "../../../abstracts/Hooks.bs.js";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as VimeoPlayer__VideoContext$PrezzeeRibbon from "./VimeoPlayer__VideoContext.bs.js";

function heightAspectStyles(aspectRatio) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
              BsCssJs$PrezzeeRibbon.overflow("hidden"),
              BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(aspectRatio)),
              BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.pct(100)),
              BsCssJs$PrezzeeRibbon.children([BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100))])
            ]);
}

var Styles = {
  heightAspectStyles: heightAspectStyles
};

function VimeoPlayer__Player(props) {
  var maintainAspectByHeight = props.maintainAspectByHeight;
  var onResize = props.onResize;
  var onLoad = props.onLoad;
  var onError = props.onError;
  var onEnded = props.onEnded;
  var onPause = props.onPause;
  var onPlay = props.onPlay;
  var setRef = props.setRef;
  var playerOptions = props.playerOptions;
  var id = props.id;
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var onPlay$1 = onPlay !== undefined ? onPlay : (function (param) {
        
      });
  var onPause$1 = onPause !== undefined ? onPause : (function (param) {
        
      });
  var onEnded$1 = onEnded !== undefined ? onEnded : (function (param) {
        
      });
  var onError$1 = onError !== undefined ? onError : (function (param) {
        
      });
  var onLoad$1 = onLoad !== undefined ? onLoad : (function (param) {
        
      });
  var onResize$1 = onResize !== undefined ? onResize : (function (param) {
        
      });
  var maintainAspectByHeight$1 = maintainAspectByHeight !== undefined ? maintainAspectByHeight : false;
  var match = React.useState(function () {
        
      });
  var setPlayer = match[1];
  var player = match[0];
  var currentVideo = React.useContext(VimeoPlayer__VideoContext$PrezzeeRibbon.context);
  var windowSize = Hooks$PrezzeeRibbon.useWindowSize(undefined, undefined);
  var match$1 = React.useState(function () {
        return 0;
      });
  var setAspectRatio = match$1[1];
  var containerRef = React.useRef(null);
  React.useEffect((function () {
          if (currentVideo !== undefined) {
            if (player !== undefined) {
              Caml_option.valFromOption(player).destroy();
              Curry._1(setPlayer, (function (param) {
                      return Caml_option.some(new Player(id, playerOptions));
                    }));
            } else {
              Curry._1(setPlayer, (function (param) {
                      return Caml_option.some(new Player(id, playerOptions));
                    }));
            }
          }
          return (function (param) {
                    Belt_Option.forEach(player, (function (playerInst) {
                            playerInst.destroy();
                          }));
                  });
        }), [currentVideo]);
  var getAspectRatio = function (param) {
    Belt_Option.forEach(player, (function (playerInst) {
            var __x = Promise.all([
                  playerInst.getVideoHeight(),
                  playerInst.getVideoWidth()
                ]);
            Js_promise.then_((function (param) {
                    var width = param[1];
                    var height = param[0];
                    Belt_Option.forEach(Caml_option.nullable_to_opt(containerRef.current), (function (container) {
                            var newAdjustedWidth = Caml_int32.div(Math.imul(container.clientHeight, width), height);
                            Curry._1(setAspectRatio, (function (param) {
                                    return newAdjustedWidth;
                                  }));
                          }));
                    return Promise.resolve(undefined);
                  }), __x);
          }));
  };
  React.useEffect((function () {
          Belt_Option.forEach(player, (function (playerInst) {
                  playerInst.on("play", onPlay$1);
                  playerInst.on("pause", onPause$1);
                  playerInst.on("ended", onEnded$1);
                  playerInst.on("error", onError$1);
                  playerInst.on("loaded", onLoad$1);
                  playerInst.on("resize", onResize$1);
                  if (setRef !== undefined) {
                    return Curry._1(setRef, playerInst);
                  }
                  
                }));
        }), [player]);
  React.useEffect((function () {
          if (maintainAspectByHeight$1) {
            getAspectRatio(undefined);
          }
          
        }), [
        player,
        windowSize
      ]);
  var stylesClass = maintainAspectByHeight$1 ? Classnames([
          heightAspectStyles(match$1[0]),
          className$1
        ]) : className$1;
  var playerEl = JsxRuntime.jsx("div", {
        ref: Caml_option.some(containerRef),
        className: stylesClass,
        id: id
      });
  if (currentVideo !== undefined) {
    return React.cloneElement(playerEl, {
                "data-vimeo-url": currentVideo
              });
  } else {
    return null;
  }
}

var Context;

var make = VimeoPlayer__Player;

export {
  Context ,
  Styles ,
  make ,
}
/* react Not a pure module */
